import { useEffect } from "react";

import changelog from "../../../../CHANGELOG.md?raw";
import { version } from "../../../../package.json";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import { currentRelease, setWhatsNewSeen } from "../state/whatsNewSeen";
import parseChangelog from "../utils/parseChangelog";
import WhatsNewView from "../views/WhatsNewView/WhatsNewView";

const releases = parseChangelog(changelog).slice(0, 20);

export default function WhatsNew() {
	const hasRight = useHasRight();

	useEffect(() => {
		setWhatsNewSeen(currentRelease);
	}, []);

	if (!hasRight("whatsNew.view")) {
		return <Unauthorized />;
	}

	return <WhatsNewView releases={releases} version={version} />;
}
